module.exports = __webpack_public_path__ + "img/office-supplies.b0672136.svg";